import { css } from 'lit';

export default css`
  [part='group'] {
    color: var(--sl-color-foreground-plain);
    margin-inline-start: auto;
  }
`;
